// extracted by mini-css-extract-plugin
export default {"tabsContainer":"Tabs_tabsContainer__DnFPs","label":"Tabs_label__423-l","item":"Tabs_item__kLL3E","content":"Tabs_content__jn9lt","tab-wrap":"Tabs_tab-wrap__IuGJu"};